import {  colors,Grid, Paper } from "@material-ui/core";
import React from "react";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { CardActionArea } from "@material-ui/core";
import { BeatLoader } from "react-spinners";

function TawlaCard(props) {
  const { item, onClick,loading} = props;
  return (
    <div  sx={{ maxWidth: 500 , minHeight:600,}}
      style={{
        padding: "10px",
        backgroundColor: colors.grey[100],
        color: "#000",
        direction: "rtl",
        border: colors.green[300]}}
    >
      <CardActionArea
        onClick={(e) => {
          onClick(item);
        }}
      >
        <Grid
          container
          style={{
            position: "absolute",

          }}
          justify="space-between"
        >

        </Grid>
        <Grid xs={12} container justifyContent="center">
          <BeatLoader loading={loading} color={colors.green[300]} />
        </Grid>
        <CardContent
          style={{
            paddingTop: "1px",
            marging: 0,
            padding: 2,
            minHeight: "80",
            maxHeight: "80",
          }}
        >
          <Typography style={{ padding: 1, fontSize: 16, fontWeight: "900" }}>
            {item.name}
          </Typography>
        </CardContent>
      </CardActionArea>
    </div>
  );
}

function TawlaList(props) {
    const {  onSelectItem,data,loading } = props;
    return (
      <Paper style={{ padding: "8px" ,}}>
        <Grid container spacing={1} >
          {data?.map((item, i) => {
            return (
              <Grid item key={i} lg={6} md={6} sm={6} xs={6}>
                <TawlaCard
                  item={item}
                  onClick={onSelectItem}
                  loading={loading}
                />
              </Grid>
            );
          })}
          <Grid xs={12} container justifyContent="center">
            <BeatLoader loading={loading} color={colors.green[300]} />
          </Grid>
        </Grid>
      </Paper>
    );
  }
  
export default TawlaList;
